import { AxiosInstance, AxiosRequestConfig } from "axios";
import { IFlightPathApiResponse } from "../BaseApiModel";
import Http from "../Http";
import { IFilteredResponse } from "../filteredApi/FilteredApiModel";
import { FilteredOrganisationApiModel } from "../filteredApi/FilteredOrganisationApiModel";
import { PhaseField } from "../../../../core/grids/builder/directorBuilder/utils/GridFields";

export class PhasesApi extends FilteredOrganisationApiModel<FP.Entities.IPhase> {
  controller: string = "phases";

  constructor(http: AxiosInstance) {
    super(http, "phases");
  }

  getByProjectIdAndName = async (
    organisationId: number,
    projectId: number,
    name: string,
    config?: AxiosRequestConfig
  ): Promise<IFilteredResponse<any>> => {
    const url = `${this.url}/${organisationId}/projects/${projectId}/${this.controller}/name/${name}`;
    let res = await this.http.get(url, config);
    if (res && res.status === 200) {
      return res.data;
    }
  };

  createProjectPhase = async (organisationId: number, projectId: number, data: any, config?: AxiosRequestConfig) => {
    const url = `${this.url}/${organisationId}/projects/${projectId}/${this.controller}`;
    let res = await this.http.post(url, data, config);
    if (res && res.status === 200) {
      return res.data;
    }
  };

  getGridData = async (
    organisationId: number,
    projectId: number,
    config?: AxiosRequestConfig
  ): Promise<IFlightPathApiResponse<FP.Entities.IPhase[]>> => {
    const url = `${this.url}/${organisationId}/projects/${projectId}/${this.controller}/grid-data`;
    let res = await this.http.get(url, config);
    return res.data;
  };

  getByIdDetailed = async (
    organisationId: number,
    projectId: number,
    phaseId: number,
    config?: AxiosRequestConfig
  ): Promise<IFlightPathApiResponse<FP.Entities.IProject[]>> => {
    const url = `${this.url}/${organisationId}/projects/${projectId}/${this.controller}/${phaseId}`;
    let res = await this.http.get(url, config);
    return res.data;
  };

  updateField = async (
    organisationId: number,
    projectId: number = null,
    phaseId: number,
    textField: string,
    idField: number,
    dateField: Date,
    numericField: number,
    phaseField: PhaseField,
    config?: AxiosRequestConfig
  ): Promise<IFlightPathApiResponse<boolean>> => {
    let data = {
      TextField: textField,
      IdField: idField,
      DateField: dateField,
      NumericField: numericField
    };
    let res = await this.http.put(
      `${this.url}/${organisationId}/projects/${projectId}/${this.controller}/${phaseId}/${phaseField}`,
      data,
      config
    );
    return res.data;
  };

  deleteRange = async (organisationId: number, projectId: number, ids: number[], config?: AxiosRequestConfig) => {
    let res = await this.http.post(
      `${this.url}/${organisationId}/projects/${projectId}/${this.controller}/delete-range`,
      ids,
      config
    );
    return res.data;
  };

  deleteGridField = async (
    organisationId: number,
    projectId: number,
    phaseId: number,
    phaseField: PhaseField,
    config?: AxiosRequestConfig
  ): Promise<IFlightPathApiResponse<boolean>> => {
    let res = await this.http.delete(
      `${this.url}/${organisationId}/projects/${projectId}/${this.controller}/${phaseId}/${phaseField}`,
      config
    );
    return res.data;
  };
}

let instance = new PhasesApi(Http);

export default instance;
